import { css } from 'linaria';
import { styled } from 'linaria/react';
import { InfoBarType } from './info-bar';

const getInfoBarColor = (type: InfoBarType) => {
	switch (type) {
		case 'warning':
			return 'var(--secondary-yellow_light)';
		case 'alert':
			return 'var(--attention-light)';
		default:
			return '#fff';
	}
};

export const InfoBarWrapper = styled.div<{ type: InfoBarType; className: string }>`
	display: flex;
	flex-direction: row;
	align-content: start;
	padding: 12px;
	margin-top: 40px;
	column-gap: 8px;
	background-color: ${({ type }) => getInfoBarColor(type)};
	border-radius: 8px;
`;

export const paragraphStyles = css`
	margin-top: 4px;
`;
